import React, {useState} from 'react';
import {Field, FieldArray} from 'formik';
import {ValuesRequestTeamType} from '../../../types/TypesPage';
import {useTranslation} from 'react-i18next';
type Props = {
	title: string;
	optionsData: {name: string; value: string}[] | '';
	fieldName: 'qlfcnames' | 'levels';
	values: ValuesRequestTeamType;
	nameOption: string;
};
const CheckBoxSelector: React.FC<Props> = ({
	title,
	optionsData,
	values,
	fieldName,
	nameOption,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const {t} = useTranslation();
	return (
		<div className="form-filter__item form-filter__item-checkbox2">
			<div className="checkbox2">
				{/*<input id="showQualification" type="checkbox" name="qualification"
                                   className="checkbox2__input2"/>*/}
				<label
					role="button"
					tabIndex={0}
					htmlFor="showQualification"
					className={`checkbox2__label2 ${isOpen ? 'active' : ''}`}
					onClick={() => setIsOpen(!isOpen)}
				>
					{title}
				</label>
			</div>
			<FieldArray name={fieldName}>
				{({push, remove}) => (
					<ul className={`checkbox2__list2 ${isOpen ? 'active' : ''}`}>
						{Array.isArray(optionsData) &&
							optionsData.map((option, index) => {
								const fieldValue = values[fieldName];
								// Поддерживаем массив, строку и число
								let fieldArray: (string | number)[] = [];
								if (Array.isArray(fieldValue)) {
									fieldArray = fieldValue;
								} else if (fieldValue !== '' && fieldValue !== null && fieldValue !== undefined) {
									fieldArray = [fieldValue];
								}
								// Преобразуем значения для сравнения (строки и числа)
								const isChecked = fieldArray.some(val => 
									String(val) === String(option.value)
								);

								return (
									<li className="checkbox2__item2" key={option.value + index}>
										<label
											htmlFor={`showQualification${index}`}
											className="checkbox2__label-list2"
										>
											{`${nameOption} ${t(option.name)}`}
										</label>
										<Field
											id={`showQualification${index}`}
											type="checkbox"
											name={`${fieldName}.${index}`}
											value={option.value}
											className="checkbox2__input-list2"
											checked={isChecked}
											onChange={() => {
												if (isChecked) {
													remove(fieldArray.indexOf(option.value));
												} else {
													push(option.value);
												}
											}}
										/>
									</li>
								);
							})}
					</ul>
				)}
			</FieldArray>
		</div>
	);
};

export default CheckBoxSelector;
